var map = {
	"./01.png": 5212,
	"./010.png": 5014,
	"./02.png": 9143,
	"./03.png": 9646,
	"./04.png": 8129,
	"./05.png": 7000,
	"./06.png": 2611,
	"./07.png": 698,
	"./08.png": 7821,
	"./09.png": 6692
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 295;